module.exports = __webpack_public_path__ + "static/media/zr_2_9.f69b4427.png";